





























import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { setCookieSeenTutorialToTrue } from '@/utils/cookie';
Vue.use(VueYouTubeEmbed);

@Component({
  components: {
    MainButton,
    Modal,
  },
})
export default class ModalVideo extends Vue {
  @Prop({ default: 'Title' })
  title: string;

  @Prop({ default: 'Description' })
  description: string;

  @Prop({ required: true })
  videoId: string;

  openModalConfirm: any = null;
  closeModalConfirm: any = null;

  get currentDomain() {
    return window.location.hostname || '';
  }

  mounted() {
    this.$emit('openModalConfirmAdd', this.openModalConfirm);
  }

  closeModal() {
    this.closeModalConfirm && this.closeModalConfirm();
  }

  openModalAdd(openModal: any) {
    this.openModalConfirm = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModalConfirm = closeModal;
  }

  playingEvent() {
    this.$sendMpEvent({
      event: this.$mp_value.VideoPlay,
      properties: { video: this.videoId },
    });
    setCookieSeenTutorialToTrue();
  }
  endedEvent() {
    this.$sendMpEvent({
      event: this.$mp_value.VideoEnd,
      properties: { video: this.videoId },
    });
  }
  errorEvent(error: any) {
    this.$sendMpEvent({
      event: this.$mp_value.VideoError,
      properties: {
        error: error && error.data,
        video: this.videoId,
      },
    });
    setCookieSeenTutorialToTrue();
  }
}
